import { signInWithEmailAndPassword } from "firebase/auth"
import React, { useState, useRef } from "react"
import { useNavigate } from "react-router-dom"
import { useProcess } from "../../contexts/ProcessContext"
import { auth } from "../../firebase/firebase"
import { resetAppInitTime } from "@/utils/appInitTime"
import { DEMO_ADMIN, DEMO_JEUNE, getBooleanEnv } from "@/config/env"

export default function Login() {
   const [showPassword, setShowPassword] = useState(false);
   const navigate = useNavigate()
   const { startProcess } = useProcess()
   const [formData, setFormData] = useState({
      email: "",
      password: "",
   })
   const formRef = useRef<HTMLFormElement | null>(null)

   const handleSubmit = async (e: React.FormEvent) => {
      e.preventDefault()
      startProcess(async () => {
         await signInWithEmailAndPassword(auth, formData.email, formData.password)
         resetAppInitTime()
         await new Promise((resolve) => setTimeout(resolve, 3000))
         navigate("/")
      })
   }

   return (
      <div className="flex-1 flex flex-col items-center justify-center">
         
         {getBooleanEnv("VITE_IS_PUBLIC_DEMO") && (
            <div className="card w-96 bg-info shadow mb-6">
               <div className="card-body items-center">
                  <div className="font-medium text-base mb-2 text-center">
                     Bienvenue sur la démo de <i>Télà?</i>, vous pouvez explorer l'app en tant qu'administrateur ou jeune.
                  </div>
                  <div className="flex gap-2 w-full">
                     <button
                        className="btn btn-_primary flex-1"
                        type="button"
                        onClick={() => {
                           setFormData({ ...DEMO_ADMIN });
                           setTimeout(() => formRef.current?.requestSubmit(), 0);
                        }}
                     >
                        Se connecter comme Admin
                     </button>
                     <button
                        className="btn btn-_secondary flex-1"
                        type="button"
                        onClick={() => {
                           setFormData({ ...DEMO_JEUNE });
                           setTimeout(() => formRef.current?.requestSubmit(), 0);
                        }}
                     >
                        Se connecter comme Jeune
                     </button>
                  </div>
               </div>
            </div>
         )}

         <div className="card w-96 bg-base-100 shadow-xl">
            <div className="card-body">
               <h2 className="card-title">Connexion</h2>
               <form onSubmit={handleSubmit} className="space-y-4" ref={formRef}>
                  <div className="form-control">
                     <label className="label">
                        <span className="label-text">Email</span>
                     </label>
                     <input
                        id="username"
                        name="username"
                        type="email"
                        className="input input-bordered w-full"
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        required
                        autoComplete="username"
                     />
                  </div>

                  <div className="form-control">
                     <label className="label">
						<span className="label-text">Mot de passe</span>
					</label>
					<div className="relative">
						<input
							id="password"
							type={showPassword ? "text" : "password"}
							name="password"
							className="input input-bordered w-full pr-10"
							value={formData.password}
							onChange={(e) => setFormData({ ...formData, password: e.target.value })}
							required
							autoComplete="current-password"
						/>
						<button
							type="button"
							className="absolute inset-y-0 right-0 flex items-center px-2"
							onClick={() => setShowPassword((prev) => !prev)}
							aria-label={showPassword ? "Masquer le mot de passe" : "Afficher le mot de passe"}
							tabIndex={0}
						>
							{!showPassword ? (
								<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.477 0 8.268 2.943 9.542 7-.656 2.11-2.197 3.973-4.542 5.001M15.54 17.44A9.978 9.978 0 0112 19c-4.477 0-8.268-2.943-9.542-7a9.978 9.978 0 012.042-3.001" />
								</svg>
							) : (
								<svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.477 0-8.268-2.943-9.542-7a9.978 9.978 0 012.042-3.001m3.1-3.1A9.978 9.978 0 0112 5c4.477 0 8.268 2.943 9.542 7a9.978 9.978 0 01-4.043 5.001M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
									<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 3l18 18" />
								</svg>
							)}
						</button>
					</div>
                     <label className="label">
                        <button
                           type="button"
                           className="label-text-alt link link-hover"
                           onClick={() => navigate("/nouveau-mot-de-passe")}
                        >
                           Mot de passe oublié ?
                        </button>
                     </label>
                  </div>

                  <button type="submit" className="btn btn-primary w-full">
                     Se connecter
                  </button>
               </form>
            </div>
         </div>
      </div>
   )
}
